import {
  ASSIGN_UNASSIGN_PRODUCTS,
  CREATE_STORE,
  DEACTIVE_STORE,
  EDIT_STORE,
  GET_STORE,
  GET_STORE_PRODUCTS,
  GET_STORES,
  REACTIVE_STORE,
  USER_LOGO
} from './ApiConstants';
import api from './ApiHandler';

export const createStore = async (payload: any) => {
  return await api.post(CREATE_STORE, { ...payload });
};

export const getStoresByPage = async (payload: any) => {
  return await api.get(GET_STORES, { params: payload });
};

export const editStore = async (payload: any) => {
  return await api.post(EDIT_STORE, { ...payload });
};

export const reactiveStore = async (payload: any) => {
  return await api.put(REACTIVE_STORE, { ...payload });
};

export const deactiveStore = async (payload: any) => {
  return await api.put(DEACTIVE_STORE, { ...payload });
};

export const getStore = async (payload: any) => {
  let response = await api.get(GET_STORE, { params: payload });
  return response;
};

export const getStoreProducts = async (payload: any) => {
  let res = await api.get(GET_STORE_PRODUCTS, { params: payload });
  return res;
};

export const assignUnassignProduct = async (payload: any) => {
  return await api.post(ASSIGN_UNASSIGN_PRODUCTS, { ...payload });
};

export const uploadFile = async (file: File, type: string) => {
  if (!file) {
    throw new Error('No file provided for upload.');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('type', type);

  let res = await api.post(USER_LOGO, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res;
};
